<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<div class="container-fluid h-100">
  <br><br><br><br><br><br>
  <div class="row h-100">
    <div class="col section-content">
      <div class="content-container">
        <div class="icon-circle">
          <i class="bi bi-box-arrow-in-left">
          </i>
        </div>
        <app-st-header-title [inputVal]="'Subscription change successful'"></app-st-header-title>
        <span class="webtext-black">Your default card has automatically been charged ${{this.amountDueFormatted}}</span>
        <br>
        <span class="webtext-black">Your subscription will expire on {{this.endDateStr}}</span>
        <br>
        <app-st-span [inputVal]="'Click here if you are not directed.'"></app-st-span>
        <br>
        <br>
        <app-st-button [label]="'Your Dashboard'" [primary]="true" (onClick)="onGoToDashboard()"></app-st-button>
      </div>
    </div>
  </div>
</div>
